import { LiveMainState } from 'features/live/interface/live';
import { useLocation } from 'react-router-dom';
import { TV_TRANSMISSION_ID } from 'shared/constants/common';
import NavigationLiveAccordion from './navigationLiveAccordion';

interface NavigationGroupProps {
	liveMenu: LiveMainState[];
}

const NavigationGroupLive = ({ liveMenu }: NavigationGroupProps) => {
	const location = useLocation();

	const getLiveEventId = parseInt(location.pathname.substring(location.pathname.lastIndexOf('/') + 1));
	const getSportCategoryFromLiveId = liveMenu.find((el) => {
		return el.events.find((e) => {
			return e.eventId === getLiveEventId;
		});
	});

	if (!liveMenu.length) return <></>;

	return (
		<>
			{liveMenu.map((item: LiveMainState, index: number) => {
				if (item.sportId === TV_TRANSMISSION_ID) {
					return null;
				} else {
					return <NavigationLiveAccordion key={`${item.sportId} ${index}`} liveSportId={getSportCategoryFromLiveId?.sportId} item={item} />;
				}
			})}
		</>
	);
};

export default NavigationGroupLive;
